<template>
  <div class="adv-banner" v-if="detail && detail.times[0] < curTime && curTime < detail.times[1]">
    <template v-if="detail.link">
      <a :href="detail.link" target="_blank">
        <el-image :src="aliUrl + detail.url"></el-image>
      </a>
    </template>
    <template v-else>
      <el-image :src="aliUrl + detail.url"></el-image>
    </template>
  </div>
</template>

<script>
  import {
    aliUrl
  } from '@/utils/app'
  export default {
    props: {
      id: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        aliUrl: aliUrl,
        curTime: new Date().getTime(),
        detail: {
          times: [0, 0]
        }
      }
    },
    mounted() {
      this.detail = this.$advs[this.id] && this.$advs[this.id]['content'] && this.$advs[this.id]['content'].length > 0 ? this.$advs[this.id]['content'][0] : this.detail
    }
  }
</script>

<style scoped>
  .adv-banner {
    margin: 10px auto;
  }
</style>